exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-summary-row[data-v-c0f99aaa] {\n  color: #464646;\n  padding: 10px 16px;\n  line-height: 20px;\n  font-size: 18px;\n  font-weight: lighter;\n  display: block;\n  width: 100%;\n}\n.product-summary-row .value[data-v-c0f99aaa] {\n  font-weight: initial;\n}\n.title[data-v-c0f99aaa] {\n  text-align: left;\n}\n", ""]);

// exports
